import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Mail, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="min-h-[80vh] flex items-center py-20">
      <div className="mx-auto max-w-md w-full px-6">
        <div className="text-center mb-10">
          <div className="h-14 w-14 rounded-2xl bg-[#2196F3] flex items-center justify-center mx-auto mb-6">
            <Mail className="h-7 w-7 text-white" />
          </div>
          <h1 className="font-display text-3xl font-extrabold text-slate-900">Mot de passe oublié</h1>
          <p className="text-slate-600 mt-2">Nous vous enverrons un lien de réinitialisation.</p>
        </div>

        {sent ? (
          <div className="bg-white rounded-3xl border border-slate-100 shadow-sm p-8 text-center space-y-4" data-testid="forgot-sent">
            <p className="text-slate-700">
              Si cet email est enregistré, un lien de réinitialisation vous a été envoyé. Vérifiez votre boîte de réception.
            </p>
            <Link to="/connexion">
              <Button variant="outline" className="rounded-full mt-4">
                <ArrowLeft className="mr-2 h-4 w-4" /> Retour à la connexion
              </Button>
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="bg-white rounded-3xl border border-slate-100 shadow-sm p-8 space-y-5" data-testid="forgot-form">
            <div className="space-y-2">
              <Label htmlFor="femail">Email</Label>
              <Input id="femail" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-12" placeholder="vous@email.fr" data-testid="forgot-email" />
            </div>
            <Button type="submit" disabled={loading} className="w-full rounded-full bg-[#2196F3] hover:bg-[#1976D2] h-12" data-testid="forgot-submit">
              {loading ? "Envoi…" : "Envoyer le lien"}
            </Button>
            <div className="text-center text-sm">
              <Link to="/connexion" className="text-[#2196F3] hover:text-[#1976D2] font-semibold">
                <ArrowLeft className="inline mr-1 h-3 w-3" /> Retour à la connexion
              </Link>
            </div>
          </form>
        )}
      </div>
    </section>
  );
}
